import { type ComponentPropsWithRef } from 'react';

import { cn } from '@/lib/utils';

interface ComposerBannerProps extends ComponentPropsWithRef<'div'> {
  side?: 'top' | 'bottom';
}

export const ComposerBanner = ({
  className,
  side = 'top',
  ...props
}: ComposerBannerProps) => {
  return (
    <div
      className={cn(
        'relative z-0',
        'px-4',
        'bg-[color-mix(in_srgb,var(--foreground-default)_5%,transparent)]',
        side === 'top'
          ? '-mb-3 pb-5 pt-2 rounded-t-2xl'
          : '-mt-3 pt-5 pb-2 rounded-b-2xl',
        className
      )}
      {...props}
    />
  );
};
